export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;
export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const SITE_TITLE = "Business Finance";

export const LOAN_TYPE_BUSINESS = "Business Loan";
export const LOAN_PURPOSE_BUSINESS = "Business";
export const LOAN_PURPOSE_DEBT_CONSOLIDATION = "Debt Consolidation";
export const LOAN_PURPOSE_OTHER = "Other";
export const EMP_STAT_SELF_EMPLOYED = "Self-employed";
export const EMP_STAT_SELF_EMPLOYED_ID = 4;
export const ABN_STATUS_NEW_ABN = "New Business ABN";

export const LOAN_TYPE_BUSINESS_ALL =
	"Working Capital/Cash Flow,Business Vehicle Finance,Equipment Finance,Truck Finance,Commercial Property Finance";
export const LOAN_TYPE_BUSINESS_WORKING_CAPITAL = "Working Capital/Cash Flow";
export const LOAN_TYPE_BUSINESS_VEHICLE = "Business Vehicle Finance";
export const LOAN_TYPE_BUSINESS_TRUCK = "Truck Finance";
export const LOAN_TYPE_BUSINESS_EQUIPMENT = "Equipment Finance";
export const LOAN_TYPE_BUSINESS_COMMERCIAL_PROPERTY = "Commercial Property Finance";

export const ABN_STATUS_REGISTERED = "I already have a registered ABN";
export const ABN_STATUS_UNREGISTERED = "I don't have a registered ABN yet";

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",
	"gamail.com": "gmail.com",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};

export const stateOption = [
	{
		option: "QLD",
		value: "QLD",
	},
	{
		option: "NSW",
		value: "NSW",
	},
	{
		option: "SA",
		value: "SA",
	},
	{
		option: "NT",
		value: "NT",
	},
	{
		option: "WA",
		value: "WA",
	},
	{
		option: "TAS",
		value: "TAS",
	},
	{
		option: "ACT",
		value: "ACT",
	},
	{
		option: "VIC",
		value: "VIC",
	},
];

export const loan_type = [
	{
		option: "Working Capital/Cash Flow",
		id: 5,
		value: "Working Capital/Cash Flow",
	},
	{
		option: "Business Vehicle Finance",
		id: 1,
		value: "Business Vehicle Finance",
	},
	{
		option: "Equipment Finance",
		id: 6,
		value: "Equipment Finance",
	},
	{
		option: "Truck Finance",
		id: 8,
		value: "Truck Finance",
	},
	{
		option: "Commercial Property Finance",
		id: 5,
		value: "Commercial Property Finance",
	},
];

export const loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
];

export const boat_asset_type = [
	{
		option: "Boat",
		value: "Boat",
	},
	{
		option: "Jet Ski / PWC",
		value: "Jet Ski / PWC",
	},
	{
		option: "Sailboat / Yacht",
		value: "Sailboat / Yacht",
	},
	{
		option: "Commercial Boat",
		value: "Commercial Boat",
	},
	{
		option: "Houseboat",
		value: "Houseboat",
	},
];

export const equipment_asset_type = [
	{
		option: "Farm Equipment",
		value: "Farm Equipment",
	},
	{
		option: "Heavy Equipment",
		value: "Heavy Equipment",
	},
	{
		option: "Manufacturing Equipment",
		value: "Manufacturing Equipment",
	},
	{
		option: "Hospitality Equipment",
		value: "Hospitality Equipment",
	},
	{
		option: "Fitness Equipment",
		value: "Fitness Equipment",
	},
	{
		option: "Medical Equipment",
		value: "Medical Equipment",
	},
	{
		option: "Dental Equipment",
		value: "Dental Equipment",
	},
	{
		option: "Low Doc Equipment Finance",
		value: "Low Doc Equipment Finance",
	},
	{
		option: "Other Equipment Finance",
		value: "Other Equipment Finance",
	},
	{
		option: "Other",
		value: "Other",
	},
];

export const personal_loan_purpose = [
	{
		option: LOAN_PURPOSE_DEBT_CONSOLIDATION,
		value: LOAN_PURPOSE_DEBT_CONSOLIDATION,
	},
	{
		option: LOAN_PURPOSE_OTHER,
		value: LOAN_PURPOSE_OTHER,
	},
];

export const purchase_stage = [
	{
		option: "Actively Looking",
		value: "Actively Looking",
	},
	{
		option: "Found One - Ready to Finance",
		value: "Found One - Ready to Finance",
	},
	{
		option: "Just Browsing",
		value: "Just Browsing",
	},
	{
		option: "Refinance Existing",
		value: "Refinance Existing",
	},
];

export const asset_age = [
	{
		option: "Brand New / Demo",
		value: "Brand New / Demo",
	},
	{
		option: "Used",
		value: "Used",
	},
	{
		option: "Refinance Existing",
		value: "Refinance Existing",
	},
	{
		option: "Not Sure Yet",
		value: "Not Sure Yet",
	},
];

export const purchase_from = [
	{
		option: "Dealer",
		value: "Dealer",
	},
	{
		option: "Auction",
		value: "Auction",
	},
	{
		option: "Private Seller",
		value: "Private Seller",
	},
	{
		option: "Not Sure Yet",
		value: "Not Sure Yet",
	},
];

export const living_status = [
	{
		option: "Home Owner - With Mortgage",
		id: 1,
		value: "Home Owner - With Mortgage",
	},
	{
		option: "Home Owner - No Mortgage",
		id: 2,
		value: "Home Owner - No Mortgage",
	},
	{
		option: "Renting",
		id: 3,
		value: "Renting",
	},
	{
		option: "Boarding",
		id: 6,
		value: "Boarding",
	},
	{
		option: "Living with Family",
		id: 4,
		value: "Living with Family",
	},
	{
		option: "Other",
		id: 10,
		value: "Other",
	},
];

export const employment_status = [
	{
		option: "Please select...",
		id: null,
		value: "",
	},
	{
		option: "Full time",
		id: 1,
		value: "Full time",
	},
	{
		option: "Part time",
		id: 2,
		value: "Part time",
	},
	{
		option: "Casual",
		id: 3,
		value: "Casual",
	},
	{
		option: "Self-employed",
		id: 4,
		value: "Self-employed",
	},
	{
		option: "Contractor",
		id: 11,
		value: "Contractor",
	},
	{
		option: "Retired",
		id: 9,
		value: "Retired",
	},
	{
		option: "Self-funded Retiree",
		id: 10,
		value: "Self-funded Retiree",
	},
	{
		option: "Not currently employed",
		id: 8,
		value: "Not currently employed",
	},
	{
		option: "Governments Benefits",
		id: 7,
		value: "Governments Benefits",
	},
];

export const credit_history = [
	{
		option: "Please select...",
		value: "",
	},
	{
		option: "Perfect Credit History",
		value: "Perfect Credit History",
	},
	{
		option: "Comparable Credit History",
		value: "Comparable Credit History",
	},
	{
		option: "Poor Credit History",
		value: "Poor Credit History",
	},
	{
		option: "Paid Defaults",
		value: "Paid Defaults",
	},
	{
		option: "Un-Paid Defaults",
		value: "Un-Paid Defaults",
	},
	{
		option: "Ex Bankrupt",
		value: "Ex Bankrupt",
	},
	{
		option: "First Time Loan",
		value: "First Time Loan",
	},
	{
		option: "I'm not sure",
		value: "I'm not sure",
	},
];

export const abn_status = [
	{
		option: "New Business ABN",
		value: "New Business ABN",
	},
	{
		option: "Less than 1 Year",
		value: "Less than 1 Year",
	},
	{
		option: "More than 1 Year",
		value: "More than 1 Year",
	},
];

export const gst_status = [
	{
		option: "Not registered for GST",
		value: "Not registered for GST",
	},
	{
		option: "6 Months +",
		value: "6 Months +",
	},
	{
		option: "12 Months +",
		value: "12 Months +",
	},
];

export const truck_asset_type = [
	{
		option: "Heavy Truck",
		value: "Heavy Truck",
	},
	{
		option: "Light Truck",
		value: "Light Truck",
	},
	{
		option: "Cab Chassis Truck",
		value: "Cab Chassis Truck",
	},
	{
		option: "Curtainsider Truck",
		value: "Curtainsider Truck",
	},
	{
		option: "Pantech Truck",
		value: "Pantech Truck",
	},
	{
		option: "Prime Mover Truck",
		value: "Prime Mover Truck",
	},
	{
		option: "Crane Truck",
		value: "Crane Truck",
	},
	{
		option: "Tow Truck",
		value: "Tow Truck",
	},
	{
		option: "Concrete Truck",
		value: "Concrete Truck",
	},
	{
		option: "Tipper Truck",
		value: "Tipper Truck",
	},
	{
		option: "Tray Truck",
		value: "Tray Truck",
	},
	{
		option: "Other Truck",
		value: "Other Truck",
	},
];

export const property_type = [
	{
		option: "Residential",
		value: "Residential",
		label: "What is the asset classification?",
		property_subtypes: [
			{
				option: "House",
				value: "House",
				property_options: [
					{
						option: "House",
						value: "House",
					},
					{
						option: "Rural Property (Under 25 Acres)",
						value: "Rural Property (Under 25 Acres)",
					},
					{
						option: "Rural Property (Over 25 Acres)",
						value: "Rural Property (Over 25 Acres)",
					},
				],
			},
			{
				option: "Townhouse",
				value: "Townhouse",
				property_options: [
					{
						option: "Townhouse",
						value: "Townhouse",
					},
					{
						option: "Villa",
						value: "Villa",
					},
				],
			},
			{
				option: "Apartment",
				value: "Apartment",
				property_options: [
					{
						option: "Apartment",
						value: "Apartment",
					},
					{
						option: "Low-Rise Apartment Block (2-4 Stories)",
						value: "Low-Rise Apartment Block (2-4 Stories)",
					},
					{
						option: "Shop Top Housing Block (3-5 Stories)",
						value: "Shop Top Housing Block (3-5 Stories)",
					},
					{
						option: "Mid-Rise Apartment Block (5-8 Stories)",
						value: "Mid-Rise Apartment Block (5-8 Stories)",
					},
					{
						option: "High-Rise Apartment Block (9+ Stories)",
						value: "High-Rise Apartment Block (9+ Stories)",
					},
					{
						option: "Serviced Apartment",
						value: "Serviced Apartment",
					},
				],
			},
			{
				option: "Other Residential",
				value: "Other Residential",
				property_options: [
					{
						option: "Community Housing",
						value: "Community Housing",
					},
					{
						option: "Other Residential",
						value: "Other Residential",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
			},
		],
	},
	{
		option: "Retail",
		value: "Retail",
		label: "What is the asset classification?",
		property_subtypes: [
			{
				option: "General Retail",
				value: "General Retail",
				property_options: [
					{
						option: "Shop",
						value: "Shop",
					},
					{
						option: "Community Shopping Complex",
						value: "Community Shopping Complex",
					},
					{
						option: "Shopping Centre/Mall",
						value: "Shopping Centre/Mall",
					},
					{
						option: "Wholesaling Yard/Unit",
						value: "Wholesaling Yard/Unit",
					},
				],
			},
			{
				option: "Specialised Retail",
				value: "Specialised Retail",
				property_options: [
					{
						option: "Car Yard",
						value: "Car Yard",
					},
					{
						option: "Nursery",
						value: "Nursery",
					},
					{
						option: "Supermarket",
						value: "Supermarket",
					},
					{
						option: "Pharmacies",
						value: "Pharmacies",
					},
					{
						option: "Showroom",
						value: "Showroom",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
				property_options: [],
			},
		],
	},
	{
		option: "Office",
		value: "Office",
		label: "What is the office classification?",
		property_subtypes: [
			{
				option: "Individual Office",
				value: "Individual Office",
				property_options: [
					{
						option: "Office",
						value: "Office",
					},
					{
						option: "Coworking Space",
						value: "Coworking Space",
					},
					{
						option: "Creative Office Space",
						value: "Creative Office Space",
					},
					{
						option: "Serviced Office",
						value: "Serviced Office",
					},
				],
			},
			{
				option: "Office Building",
				value: "Office Building",
				property_options: [
					{
						option: "Low Rise Office Building (2-4 Stories)",
						value: "Low Rise Office Building (2-4 Stories)",
					},
					{
						option: "Mid Rise Office Building (5-8 Stories)",
						value: "Mid Rise Office Building (5-8 Stories)",
					},
					{
						option: "High Rise Office Building (9+ Stories)",
						value: "High Rise Office Building (9+ Stories)",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
				property_options: [],
			},
		],
	},
	{
		option: "Land",
		value: "Land",
		label: "What is the land classification?",
		property_subtypes: [
			{
				option: "Undeveloped Land",
				value: "Undeveloped Land",
				property_options: [
					{
						option: "Vacant Land",
						value: "Vacant Land",
					},
					{
						option: "Vacant Agricultural Land",
						value: "Vacant Agricultural Land",
					},
					{
						option: "Wildlife and Nature Reserve",
						value: "Wildlife and Nature Reserve",
					},
				],
			},
			{
				option: "Previously Developed Land",
				value: "Previously Developed Land",
				property_options: [
					{
						option: "Nature Reserve",
						value: "Nature Reserve",
					},
					{
						option: "Partially Complete Construction",
						value: "Partially Complete Construction",
					},
					{
						option: "Contaminated Land",
						value: "Contaminated Land",
					},
					{
						option: "Parklands",
						value: "Parklands",
					},
					{
						option: "Abandoned Site",
						value: "Abandoned Site",
					},
					{
						option: "Derelict Land",
						value: "Derelict Land",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
				property_options: [],
			},
		],
	},
	{
		option: "Agriculture",
		value: "Agriculture",
		label: "What is the agricultural classification?",
		property_subtypes: [
			{
				option: "Pastoral",
				value: "Pastoral",
				property_options: [
					{
						option: "Farm (Livestock)",
						value: "Farm (Livestock)",
					},
					{
						option: "Chicken Coop",
						value: "Chicken Coop",
					},
					{
						option: "Pig Farm / Piggery",
						value: "Pig Farm / Piggery",
					},
					{
						option: "Stable",
						value: "Stable",
					},
				],
			},
			{
				option: "Crop Growing",
				value: "Crop Growing",
				property_options: [
					{
						option: "Farm (Crops)",
						value: "Farm (Crops)",
					},
					{
						option: "Greenhouse",
						value: "Greenhouse",
					},
					{
						option: "Silo",
						value: "Silo",
					},
					{
						option: "Orchard",
						value: "Orchard",
					},
					{
						option: "Vineyard",
						value: "Vineyard",
					},
				],
			},
			{
				option: "Mixed Growing",
				value: "Mixed Growing",
				property_options: [
					{
						option: "Farm (Mixed)",
						value: "Farm (Mixed)",
					},
				],
			},
			{
				option: "Other Farm",
				value: "Other Farm",
				property_options: [
					{
						option: "Rural Home",
						value: "Rural Home",
					},
					{
						option: "Barn",
						value: "Barn",
					},
					{
						option: "Rural Shed",
						value: "Rural Shed",
					},
					{
						option: "Water Title",
						value: "Water Title",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
				property_options: [],
			},
		],
	},
	{
		option: "Industrial",
		value: "Industrial",
		label: "What is the industrial classification?",
		property_subtypes: [
			{
				option: "Warehouse and Distribution",
				value: "Warehouse and Distribution",
				property_options: [
					{
						option: "Warehouse",
						value: "Warehouse",
					},
					{
						option: "Distribution Centre",
						value: "Distribution Centre",
					},
					{
						option: "Refrigeration and Cold Store",
						value: "Refrigeration and Cold Store",
					},
					{
						option: "Flex Building",
						value: "Flex Building",
					},
					{
						option: "Industrial Shed",
						value: "Industrial Shed",
					},
					{
						option: "Storage Complex",
						value: "Storage Complex",
					},
				],
			},
			{
				option: "Manufacturing",
				value: "Manufacturing",
				property_options: [
					{
						option: "Factory Unit",
						value: "Factory Unit",
					},

					{
						option: "Factory/Production Plant",
						value: "Factory/Production Plant",
					},

					{
						option: "Oil Refinery",
						value: "Oil Refiner",
					},

					{
						option: "Natural Gas Refinery",
						value: "Natural Gas Refinery",
					},

					{
						option: "Abattoir/Slaughterhouse",
						value: "Abattoir/Slaughterhouse",
					},

					{
						option: "Chemicals and Plastics Manufacturing Facility",
						value: "Chemicals and Plastics Manufacturing Facility",
					},

					{
						option: "Food Processing Facility",
						value: "Food Processing Facility",
					},

					{
						option: "Clothing and Textiles Manufacturing Facility",
						value: "Clothing and Textiles Manufacturing Facility",
					},

					{
						option: "Scrapyard/Wrecking Yard",
						value: "Scrapyard/Wrecking Yard",
					},

					{
						option: "Other Manufacturing Facility",
						value: "Other Manufacturing Facility",
					},
				],
			},
			{
				option: "Mining and Extraction",
				value: "Mining and Extraction",
				property_options: [
					{
						option: "Rare Earth Mine",
						value: "Rare Earth Mine",
					},
					{
						option: "Energy Mine",
						value: "Energy Mine",
					},
					{
						option: "Metal Mine",
						value: "Metal Mine",
					},
					{
						option: "Mining Tenement/Lease",
						value: "Mining Tenement/Lease",
					},
					{
						option: "Natural Gas Power Plant",
						value: "Natural Gas Power Plant",
					},
					{
						option: "Natural Gas Well",
						value: "Natural Gas Well",
					},
					{
						option: "Oil Field",
						value: "Oil Field",
					},
					{
						option: "Quarry",
						value: "Quarry",
					},
				],
			},
			{
				option: "Electricity Generation",
				value: "Electricity Generation",
				property_options: [
					{
						option: "Solar Farm",
						value: "Solar Farm",
					},
					{
						option: "Wind Farm",
						value: "Wind Farm",
					},
					{
						option: "Coal-Fired Power Station",
						value: "Coal-Fired Power Station",
					},
					{
						option: "Hydroelectric Power Plant",
						value: "Hydroelectric Power Plant",
					},
					{
						option: "Thermal Power Plant",
						value: "Thermal Power Plant",
					},
					{
						option: "Nuclear Power Plant",
						value: "Nuclear Power Plant",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
				property_options: [],
			},
		],
	},
	{
		option: "Infrastructure & Civic",
		value: "Infrastructure and Civic",
		label: "What is the classification?",
		property_subtypes: [
			{
				option: "Infrastructure",
				value: "Infrastructure",
				property_options: [
					{
						option: "Desalination Plant",
						value: "Desalination Plant",
					},
					{
						option: "Power Distribution Plant",
						value: "Power Distribution Plant",
					},
					{
						option: "Dam",
						value: "Dam",
					},
				],
			},
			{
				option: "Civic",
				value: "Civic",
				property_options: [
					{
						option: "Fire Station",
						value: "Fire Station",
					},
					{
						option: "Ambulance Station",
						value: "Ambulance Station",
					},
					{
						option: "Police Station",
						value: "Police Station",
					},
					{
						option: "Detention Centre",
						value: "Detention Centre",
					},
					{
						option: "Prison/Correctional Facility",
						value: "Prison/Correctional Facility",
					},
					{
						option: "Composting Facility",
						value: "Composting Facility",
					},
					{
						option: "Waste Management Centre",
						value: "Waste Management Centre",
					},
					{
						option: "Library",
						value: "Library",
					},
					{
						option: "Rubbish Dump",
						value: "Rubbish Dump",
					},
					{
						option: "Community Centre",
						value: "Community Centre",
					},
					{
						option: "Lighthouse",
						value: "Lighthouse",
					},
				],
			},
			{
				option: "Telecommunications",
				value: "Telecommunications",
				property_options: [
					{
						option: "Cell Site",
						value: "Cell Site",
					},
					{
						option: "Radio Broadcasting",
						value: "Radio Broadcasting",
					},
					{
						option: "Lighthouse",
						value: "Lighthouse",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
				property_options: [],
			},
		],
	},
	{
		option: "Specialised",
		value: "Specialised",
		label: "What is the commercial classification?",
		property_subtypes: [
			{
				option: "Health and Medical",
				value: "Health and Medical",
				property_options: [
					{
						option: "Medical Centre/Suite",
						value: "Medical Centre/Suite",
					},

					{
						option: "Hospital",
						value: "Hospital",
					},

					{
						option: "Aged Care Residence",
						value: "Aged Care Residence",
					},

					{
						option: "Aged Care Facility",
						value: "Aged Care Facility",
					},

					{
						option: "Mental Health Clinic",
						value: "Mental Health Clinic",
					},
				],
			},
			{
				option: "Accommodation",
				value: "Accommodation",
				property_options: [
					{
						option: "Hotel",
						value: "Hotel",
					},
					{
						option: "Motel",
						value: "Motel",
					},
					{
						option: "Serviced Apartments",
						value: "Serviced Apartments",
					},
					{
						option: "Caravan Park",
						value: "Caravan Park",
					},
					{
						option: "Boarding House",
						value: "Boarding House",
					},
					{
						option: "Resort",
						value: "Resort",
					},
					{
						option: "Recreational Retreat/Campground",
						value: "Recreational Retreat/Campground",
					},
					{
						option: "Wellness Retreat",
						value: "Wellness Retreat",
					},
				],
			},
			{
				option: "Hospitality and Food Services",
				value: "Hospitality and Food Services",
				property_options: [
					{
						option: "Restaurant",
						value: "Restaurant",
					},
					{
						option: "Bar",
						value: "Bar",
					},
					{
						option: "Pub",
						value: "Pub",
					},
					{
						option: "Function Centre",
						value: "Function Centre",
					},
					{
						option: "Registered Clubs",
						value: "Registered Clubs",
					},
					{
						option: "Brewery",
						value: "Brewery",
					},
					{
						option: "Winery",
						value: "Winery",
					},
					{
						option: "Distillery",
						value: "Distiller",
					},
					{
						option: "Nightclub",
						value: "Nightclub",
					},
				],
			},
			{
				option: "Transportation",
				value: "Transportation",
				property_options: [
					{
						option: "Airport",
						value: "Airport",
					},
					{
						option: "Hangar",
						value: "Hangar",
					},
					{
						option: "Shipyard",
						value: "Shipyard",
					},
					{
						option: "Dry Dock",
						value: "Dry Dock",
					},
					{
						option: "Ferry Terminal",
						value: "Ferry Terminal",
					},
					{
						option: "Cruise Terminal",
						value: "Cruise Terminal",
					},
					{
						option: "Boathouse",
						value: "Boathouse",
					},
					{
						option: "Car Parking Space",
						value: "Car Parking Space",
					},
					{
						option: "Lock-Up Garage",
						value: "Lock-Up Garage",
					},
					{
						option: "Car Parking Station",
						value: "Car Parking Station",
					},
					{
						option: "Truck Stop/Depot",
						value: "Truck Stop/Depot",
					},
					{
						option: "Marina",
						value: "Marina",
					},
					{
						option: "Launch Pad",
						value: "Launch Pad",
					},
					{
						option: "Container Terminal",
						value: "Container Terminal",
					},
				],
			},
			{
				option: "Sports, Leisure and Arts",
				value: "Sports, Leisure and Arts",
				property_options: [
					{
						option: "Brothel",
						value: "Brothel",
					},
					{
						option: "Theme Park",
						value: "Theme Park",
					},
					{
						option: "Cinema",
						value: "Cinema",
					},
					{
						option: "Casino",
						value: "Casino",
					},
					{
						option: "Bowling Alley",
						value: "Bowling Alley",
					},
					{
						option: "Gymnasium",
						value: "Gymnasium",
					},
					{
						option: "Swimming Pool",
						value: "Swimming Pool",
					},
					{
						option: "Leisure Centre",
						value: "Leisure Centre",
					},
					{
						option: "Arena/Stadium",
						value: "Arena/Stadium",
					},
					{
						option: "Ski Resort",
						value: "Ski Resort",
					},
					{
						option: "Film Studio",
						value: "Film Studio",
					},
					{
						option: "Arts Centre",
						value: "Arts Centre",
					},
					{
						option: "Performance Hall",
						value: "Performance Hall",
					},
					{
						option: "Art Gallery",
						value: "Art Gallery",
					},
					{
						option: "Theatre",
						value: "Theatre",
					},
					{
						option: "Bath House",
						value: "Bath House",
					},
					{
						option: "Sports Complex",
						value: "Sports Complex",
					},
					{
						option: "Indoor Sports Complex",
						value: "Indoor Sports Complex",
					},
					{
						option: "Recording Studio",
						value: "Recording Studio",
					},
					{
						option: "Convention Centre",
						value: "Convention Centre",
					},
					{
						option: "Conference Centre",
						value: "Conference Centre",
					},
					{
						option: "Museum",
						value: "Museum",
					},
					{
						option: "Motor Racing Track",
						value: "Motor Racing Track",
					},
					{
						option: "Animal Racecourse",
						value: "Animal Racecourse",
					},
					{
						option: "Gardens",
						value: "Gardens",
					},
				],
			},
			{
				option: "Religious Services",
				value: "Religious Services",
				property_options: [
					{
						option: "Religious Site",
						value: "Religious Site",
					},
					{
						option: "Church",
						value: "Church",
					},
					{
						option: "Synagogue",
						value: "Synagogue",
					},
					{
						option: "Mosque",
						value: "Mosque",
					},
					{
						option: "Temple",
						value: "Temple",
					},
					{
						option: "Monastery",
						value: "Monastery",
					},
					{
						option: "Other Places of Worship",
						value: "Other Places of Worship",
					},
				],
			},
			{
				option: "Burial and Death Services",
				value: "Burial and Death Services",
				property_options: [
					{
						option: "Graveyard",
						value: "Graveyard",
					},
					{
						option: "Crematorium",
						value: "Crematorium",
					},
				],
			},
			{
				option: "Education",
				value: "Education",
				property_options: [
					{
						option: "Childcare",
						value: "Childcare",
					},
					{
						option: "School",
						value: "School",
					},
					{
						option: "Tertiary Education Facility",
						value: "Tertiary Education Facility",
					},
				],
			},
			{
				option: "Hi-Tech",
				value: "Hi-Tech",
				property_options: [
					{
						option: "Medical Research Facility",
						value: "Medical Research Facility",
					},
					{
						option: "Scientific Research Facility",
						value: "Scientific Research Facility",
					},
					{
						option: "Laboratory",
						value: "Laboratory",
					},
					{
						option: "Data Centre/Switching Facility",
						value: "Data Centre/Switching Facility",
					},
				],
			},
			{
				option: "Motor Vehicle",
				value: "Motor Vehicle",
				property_options: [
					{
						option: "Mechanic",
						value: "Mechanic",
					},
					{
						option: "Carwash",
						value: "Carwash",
					},
					{
						option: "Fuel Station",
						value: "Fuel Station",
					},
					{
						option: "Smash Repairs Workshop",
						value: "Smash Repairs Workshop",
					},
				],
			},
			{
				option: "Animal and Wildlife",
				value: "Animal and Wildlife",
				property_options: [
					{
						option: "Pet Hotel/Boarding",
						value: "Pet Hotel/Boarding",
					},
					{
						option: "Horse Agistment School",
						value: "Horse Agistment School",
					},
					{
						option: "Zoo",
						value: "Zoo",
					},
					{
						option: "Wildlife Park",
						value: "Wildlife Park",
					},
					{
						option: "Wildlife Centre",
						value: "Wildlife Centre",
					},
				],
			},
			{
				option: "Other Specialised",
				value: "Other Specialised",
				property_options: [
					{
						option: "Charity House",
						value: "Charity House",
					},
					{
						option: "Archaeological Dig",
						value: "Archaeological Dig",
					},
				],
			},
			{
				option: "Other",
				value: "Other",
				property_options: [],
			},
		],
	},
];

export const property_category_residential = [
	{
		option: "House",
		value: "House",
	},
];

export const property_location = [
	{
		id: 1,
		option: "Metro",
		value: "Metro",
	},
	{
		id: 2,
		option: "Regional",
		value: "Regional",
	},
	{
		id: 3,
		option: "Rural",
		value: "Rural",
	},
];

export const subcategories = [
	{
		category: "Residential",
		subcategory: "House",
		label: "What type of property?",
	},
	{
		category: "Residential",
		subcategory: "Townhouse",
		label: "What type of property?",
	},
	{
		category: "Residential",
		subcategory: "Apartment",
		label: "What type of apartment?",
	},
	{
		category: "Residential",
		subcategory: "Other Residential",
		label: "What type of housing?",
	},
	{
		category: "Residential",
		subcategory: "Other",
		label: "Please specify the type of property.",
	},
	{
		category: "Retail",
		subcategory: "General Retail",
		label: "What type of establishment?",
	},
	{
		category: "Retail",
		subcategory: "Specialised Retail",
		label: "What type of asset?",
	},
	{
		category: "Retail",
		subcategory: "Other",
		label: "Please specify the type of retail business.",
	},
	{
		category: "Office",
		subcategory: "Individual Office",
		label: "What type of office?",
	},
	{
		category: "Office",
		subcategory: "Office Building",
		label: "What type of office building?",
	},
	{
		category: "Office",
		subcategory: "Other",
		label: "Please specify the type of office.",
	},
	{
		category: "Land",
		subcategory: "Undeveloped Land",
		label: "What type of land?",
	},
	{
		category: "Land",
		subcategory: "Previously Developed Land",
		label: "What type of land?",
	},
	{
		category: "Land",
		subcategory: "Other",
		label: "Please specify the type of land.",
	},
	{
		category: "Agriculture",
		subcategory: "Pastoral",
		label: "What type of sector?",
	},
	{
		category: "Agriculture",
		subcategory: "Crop Growing",
		label: "What type of sector?",
	},
	{
		category: "Agriculture",
		subcategory: "Mixed Growing",
		label: "What type of farm?",
	},
	{
		category: "Agriculture",
		subcategory: "Other Farm",
		label: "What type of asset?",
	},
	{
		category: "Agriculture",
		subcategory: "Other",
		label: "Please specify the type of agricultural.",
	},
	{
		category: "Industrial",
		subcategory: "Warehouse & Distribution",
		label: "What type of sector?",
	},
	{
		category: "Industrial",
		subcategory: "Manufacturing",
		label: "What type of sector?",
	},
	{
		category: "Industrial",
		subcategory: "Mining and Extraction",
		label: "What type of sector?",
	},
	{
		category: "Industrial",
		subcategory: "Electricity Generation",
		label: "What type of sector?",
	},
	{
		category: "Industrial",
		subcategory: "Other",
		label: "Please specify the type of industrial.",
	},
	{
		category: "Infrastructure and Civic",
		subcategory: "Infrastructure",
		label: "What type of sector?",
	},
	{
		category: "Infrastructure and Civic",
		subcategory: "Civic",
		label: "What type of facility?",
	},
	{
		category: "Infrastructure and Civic",
		subcategory: "Telecommunications",
		label: "What type of site?",
	},
	{
		category: "Infrastructure and Civic",
		subcategory: "Other",
		label: "Please specify the type of civic project.",
	},
	{
		category: "Specialised",
		subcategory: "Health & Medical",
		label: "What type of facility?",
	},
	{
		category: "Specialised",
		subcategory: "Accommodation",
		label: "What type of infrastructure?",
	},
	{
		category: "Specialised",
		subcategory: "Hospitality & Food Services",
		label: "What type of facility?",
	},
	{
		category: "Specialised",
		subcategory: "Transportation",
		label: "What Type of Services Operation?",
	},
	{
		category: "Specialised",
		subcategory: "Sports, Leisure & Arts",
		label: "What type of facility?",
	},
	{
		category: "Specialised",
		subcategory: "Religious Services",
		label: "What type of premises?",
	},
	{
		category: "Specialised",
		subcategory: "Burial & Death Services",
		label: "What type of site?",
	},
	{
		category: "Specialised",
		subcategory: "Education",
		label: "What type of facility?",
	},
	{
		category: "Specialised",
		subcategory: "Hi-Tech",
		label: "What type of facility?",
	},
	{
		category: "Specialised",
		subcategory: "Motor Vehicle",
		label: "What type of establishment?",
	},
	{
		category: "Specialised",
		subcategory: "Animal & Wildlife",
		label: "What type of infrastructure?",
	},
	{
		category: "Specialised",
		subcategory: "Other Specialised",
		label: "What type of infrastructure?",
	},
	{
		category: "Specialised",
		subcategory: "Other",
		label: "Please specify the type of specialised property.",
	},
];

export const options = [
	// Residential
	{ subcategory: "House", option: "House" },
	{ subcategory: "House", option: "Rural Property (Under 25 Acres)" },
	{ subcategory: "House", option: "Rural Property (Over 25 Acres)" },
	{ subcategory: "Townhouse", option: "Townhouse" },
	{ subcategory: "Townhouse", option: "Villa" },
	{ subcategory: "Apartment", option: "Apartment" },
	{
		subcategory: "Apartment",
		option: "Low-Rise Apartment Block (2-4 Stories)",
	},
	{
		subcategory: "Apartment",
		option: "Shop Top Housing Block (3-5 Stories)",
	},
	{
		subcategory: "Apartment",
		option: "Mid-Rise Apartment Block (5-8 Stories)",
	},
	{
		subcategory: "Apartment",
		option: "High-Rise Apartment Block (9+ Stories)",
	},
	{ subcategory: "Apartment", option: "Serviced Apartment" },
	{ subcategory: "Other Residential", option: "Community Housing" },
	{ subcategory: "Other Residential", option: "Other Residential" },

	// Retail
	{ subcategory: "General Retail", option: "Shop" },
	{ subcategory: "General Retail", option: "Community Shopping Complex" },
	{ subcategory: "General Retail", option: "Shopping Centre/Mall" },
	{ subcategory: "General Retail", option: "Wholesaling Yard/Unit" },
	{ subcategory: "Specialised Retail", option: "Car Yard" },
	{ subcategory: "Specialised Retail", option: "Nursery" },
	{ subcategory: "Specialised Retail", option: "Supermarket" },
	{ subcategory: "Specialised Retail", option: "Pharmacies" },
	{ subcategory: "Specialised Retail", option: "Showroom" },
	{ subcategory: "Other", option: "other" },

	// Office
	{ subcategory: "Individual Office", option: "Office" },
	{ subcategory: "Individual Office", option: "Coworking Space" },
	{ subcategory: "Individual Office", option: "Creative Office Space" },
	{ subcategory: "Individual Office", option: "Serviced Office" },
	{
		subcategory: "Office Building",
		option: "Low Rise Office Building (2-4 Stories)",
	},
	{
		subcategory: "Office Building",
		option: "Mid Rise Office Building (5-8 Stories)",
	},
	{
		subcategory: "Office Building",
		option: "High Rise Office Building (9+ Stories)",
	},
	{ subcategory: "Other", option: "other" },

	// Land
	{ subcategory: "Undeveloped Land", option: "Vacant Land" },
	{ subcategory: "Undeveloped Land", option: "Vacant Agriculture Land" },
	{ subcategory: "Undeveloped Land", option: "Wildlife & Nature Reserve" },
	{ subcategory: "Previously Developed Land", option: "Nature Reserve" },
	{
		subcategory: "Previously Developed Land",
		option: "Partially Complete Construction",
	},
	{ subcategory: "Previously Developed Land", option: "Contaminated Land" },
	{ subcategory: "Previously Developed Land", option: "Parklands" },
	{ subcategory: "Previously Developed Land", option: "Abandoned Site" },
	{ subcategory: "Previously Developed Land", option: "Derelict Land" },
	{ subcategory: "Other", option: "other" },

	// Agriculture
	{ subcategory: "Pastoral", option: "Farm (Livestock)" },
	{ subcategory: "Pastoral", option: "Chicken Coop" },
	{ subcategory: "Pastoral", option: "Pig Farm/Piggery" },
	{ subcategory: "Pastoral", option: "Stable" },
	{ subcategory: "Crop Growing", option: "Farm (Crops)" },
	{ subcategory: "Crop Growing", option: "Greenhouse" },
	{ subcategory: "Crop Growing", option: "Silo" },
	{ subcategory: "Crop Growing", option: "Orchard" },
	{ subcategory: "Crop Growing", option: "Vineyard" },
	{ subcategory: "Mixed Growing", option: "Farm (Mixed)" },
	{ subcategory: "Other Farm", option: "Rural Home" },
	{ subcategory: "Other Farm", option: "Barn" },
	{ subcategory: "Other Farm", option: "Rural Shed" },
	{ subcategory: "Other Farm", option: "Water Title" },
	{ subcategory: "Other", option: "other" },

	// Industrial
	{ subcategory: "Warehouse & Distribution", option: "Warehouse" },
	{ subcategory: "Warehouse & Distribution", option: "Distribution Centre" },
	{
		subcategory: "Warehouse & Distribution",
		option: "Refrigeration & Cold Store",
	},
	{ subcategory: "Warehouse & Distribution", option: "Flex Building" },
	{ subcategory: "Warehouse & Distribution", option: "Industrial Shed" },
	{ subcategory: "Warehouse & Distribution", option: "Storage Complex" },
	{ subcategory: "Manufacturing", option: "Factory Unit" },
	{ subcategory: "Manufacturing", option: "Factory/Production Plant" },
	{ subcategory: "Manufacturing", option: "Oil Refinery" },
	{ subcategory: "Manufacturing", option: "Natural Gas Refinery" },
	{ subcategory: "Manufacturing", option: "Abattoir/Slaughterhouse" },
	{
		subcategory: "Manufacturing",
		option: "Chemicals & Plastics Manufacturing Facility",
	},
	{ subcategory: "Manufacturing", option: "Food Processing Facility" },
	{
		subcategory: "Manufacturing",
		option: "Clothing & Textiles Manufacturing Facility",
	},
	{ subcategory: "Manufacturing", option: "Scrapyard/Wrecking Yard" },
	{ subcategory: "Manufacturing", option: "Other Manufacturing Facility" },
	{ subcategory: "Mining and Extraction", option: "Rare Earth Mine" },
	{ subcategory: "Mining and Extraction", option: "Energy Mine" },
	{ subcategory: "Mining and Extraction", option: "Metal Mine" },
	{ subcategory: "Mining and Extraction", option: "Mining Tenement/Lease" },
	{ subcategory: "Mining and Extraction", option: "Natural Gas Power Plant" },
	{ subcategory: "Mining and Extraction", option: "Natural Gas Well" },
	{ subcategory: "Mining and Extraction", option: "Oil Field" },
	{ subcategory: "Mining and Extraction", option: "Quarry" },
	{ subcategory: "Electricity Generation", option: "Solar Farm" },
	{ subcategory: "Electricity Generation", option: "Wind Farm" },
	{
		subcategory: "Electricity Generation",
		option: "Coal-Fired Power Station",
	},
	{
		subcategory: "Electricity Generation",
		option: "Hydroelectric Power Plant",
	},
	{ subcategory: "Electricity Generation", option: "Thermal Power Plant" },
	{ subcategory: "Electricity Generation", option: "Nuclear Power Plant" },
	{ subcategory: "Other", option: "other" },

	// Infrastructure and Infrastructure and Civic
	{ subcategory: "Infrastructure", option: "Desalination Plant" },
	{ subcategory: "Infrastructure", option: "Power Distribution Plant" },
	{ subcategory: "Infrastructure", option: "Dam" },
	{ subcategory: "Civic", option: "Fire Station" },
	{ subcategory: "Civic", option: "Ambulance Station" },
	{ subcategory: "Civic", option: "Police Station" },
	{ subcategory: "Civic", option: "Detention Centre" },
	{ subcategory: "Civic", option: "Prison/Correctional Facility" },
	{ subcategory: "Civic", option: "Composting Facility" },
	{ subcategory: "Civic", option: "Waste Management Centre" },
	{ subcategory: "Civic", option: "Library" },
	{ subcategory: "Civic", option: "Rubbish Dump" },
	{ subcategory: "Civic", option: "Community Centre" },
	{ subcategory: "Civic", option: "Lighthouse" },
	{ subcategory: "Telecommunications", option: "Cell Site" },
	{ subcategory: "Telecommunications", option: "Radio Broadcasting" },
	{ subcategory: "Other", option: "other" },

	// Specialised
	{ subcategory: "Health & Medical", option: "Medical Centre/Suite" },
	{ subcategory: "Health & Medical", option: "Hospital" },
	{ subcategory: "Health & Medical", option: "Aged Care Residence" },
	{ subcategory: "Health & Medical", option: "Aged Care Facility" },
	{ subcategory: "Health & Medical", option: "Mental Health Clinic" },
	{ subcategory: "Accommodation", option: "Hotel" },
	{ subcategory: "Accommodation", option: "Motel" },
	{ subcategory: "Accommodation", option: "Hostel" },
	{ subcategory: "Accommodation", option: "Serviced Apartments" },
	{ subcategory: "Accommodation", option: "Caravan Park" },
	{ subcategory: "Accommodation", option: "Boarding House" },
	{ subcategory: "Accommodation", option: "Resort" },
	{ subcategory: "Accommodation", option: "Recreational Retreat/Campground" },
	{ subcategory: "Accommodation", option: "Wellness Retreat" },
	{ subcategory: "Hospitality & Food Services", option: "Restaurant" },
	{ subcategory: "Hospitality & Food Services", option: "Bar" },
	{ subcategory: "Hospitality & Food Services", option: "Pub" },
	{ subcategory: "Hospitality & Food Services", option: "Function Centre" },
	{ subcategory: "Hospitality & Food Services", option: "Registered Clubs" },
	{ subcategory: "Hospitality & Food Services", option: "Brewery" },
	{ subcategory: "Hospitality & Food Services", option: "Winery" },
	{ subcategory: "Hospitality & Food Services", option: "Distillery" },
	{ subcategory: "Hospitality & Food Services", option: "Nightclub" },
	{ subcategory: "Transportation", option: "Airport" },
	{ subcategory: "Transportation", option: "Hangar" },
	{ subcategory: "Transportation", option: "Shipyard" },
	{ subcategory: "Transportation", option: "Dry Dock" },
	{ subcategory: "Transportation", option: "Ferry Terminal" },
	{ subcategory: "Transportation", option: "Cruise Terminal" },
	{ subcategory: "Transportation", option: "Boathouse" },
	{ subcategory: "Transportation", option: "Car Parking Space" },
	{ subcategory: "Transportation", option: "Lock-Up Garage" },
	{ subcategory: "Transportation", option: "Car Parking Station" },
	{ subcategory: "Transportation", option: "Truck Stop/Depot" },
	{ subcategory: "Transportation", option: "Marina" },
	{ subcategory: "Transportation", option: "Launch Pad" },
	{ subcategory: "Transportation", option: "Container Terminal" },
	{ subcategory: "Sports, Leisure & Arts", option: "Brothel" },
	{ subcategory: "Sports, Leisure & Arts", option: "Theme Park" },
	{ subcategory: "Sports, Leisure & Arts", option: "Cinema" },
	{ subcategory: "Sports, Leisure & Arts", option: "Casino" },
	{ subcategory: "Sports, Leisure & Arts", option: "Bowling Alley" },
	{ subcategory: "Sports, Leisure & Arts", option: "Gymnasium" },
	{ subcategory: "Sports, Leisure & Arts", option: "Swimming Pool" },
	{ subcategory: "Sports, Leisure & Arts", option: "Leisure Centre" },
	{ subcategory: "Sports, Leisure & Arts", option: "Arena/Stadium" },
	{ subcategory: "Sports, Leisure & Arts", option: "Ski Resort" },
	{ subcategory: "Sports, Leisure & Arts", option: "Film Studio" },
	{ subcategory: "Sports, Leisure & Arts", option: "Arts Centre" },
	{ subcategory: "Sports, Leisure & Arts", option: "Performance Hall" },
	{ subcategory: "Sports, Leisure & Arts", option: "Art Gallery" },
	{ subcategory: "Sports, Leisure & Arts", option: "Theatre" },
	{ subcategory: "Sports, Leisure & Arts", option: "Bath House" },
	{ subcategory: "Sports, Leisure & Arts", option: "Sports Complex" },
	{ subcategory: "Sports, Leisure & Arts", option: "Indoor Sports Complex" },
	{ subcategory: "Sports, Leisure & Arts", option: "Recording Studio" },
	{ subcategory: "Sports, Leisure & Arts", option: "Convention Centre" },
	{ subcategory: "Sports, Leisure & Arts", option: "Conference Centre" },
	{ subcategory: "Sports, Leisure & Arts", option: "Museum" },
	{ subcategory: "Sports, Leisure & Arts", option: "Motor Racing Track" },
	{ subcategory: "Sports, Leisure & Arts", option: "Animal Racecourse" },
	{ subcategory: "Sports, Leisure & Arts", option: "Gardens" },
	{ subcategory: "Religious Services", option: "Religious Site" },
	{ subcategory: "Religious Services", option: "Church" },
	{ subcategory: "Religious Services", option: "Synagogue" },
	{ subcategory: "Religious Services", option: "Mosque" },
	{ subcategory: "Religious Services", option: "Temple" },
	{ subcategory: "Religious Services", option: "Monastery" },
	{ subcategory: "Religious Services", option: "Other Places of Worship" },
	{ subcategory: "Burial & Death Services", option: "Graveyard" },
	{ subcategory: "Burial & Death Services", option: "Crematorium" },
	{ subcategory: "Education", option: "Childcare" },
	{ subcategory: "Education", option: "School" },
	{ subcategory: "Education", option: "Tertiary Education Facility" },
	{ subcategory: "Hi-Tech", option: "Medical Research Facility" },
	{ subcategory: "Hi-Tech", option: "Scientific Research Facility" },
	{ subcategory: "Hi-Tech", option: "Laboratory" },
	{ subcategory: "Hi-Tech", option: "Data Centre/Switching Facility" },
	{ subcategory: "Motor Vehicle", option: "Mechanic" },
	{ subcategory: "Motor Vehicle", option: "Carwash" },
	{ subcategory: "Motor Vehicle", option: "Fuel Station" },
	{ subcategory: "Motor Vehicle", option: "Smash Repairs Workshop" },
	{ subcategory: "Animal & Wildlife", option: "Pet Hotel/Boarding" },
	{ subcategory: "Animal & Wildlife", option: "Horse Agistment School" },
	{ subcategory: "Animal & Wildlife", option: "Zoo" },
	{ subcategory: "Animal & Wildlife", option: "Wildlife Park" },
	{ subcategory: "Animal & Wildlife", option: "Wildlife Centre" },
	{ subcategory: "Other Specialised", option: "Charity House" },
	{ subcategory: "Other Specialised", option: "Archaeological Dig" },
	{ subcategory: "Other", option: "other" },
];

export const business_abn_status = [
	{
		option: "I already have a registered ABN",
		value: "I already have a registered ABN",
	},
	{
		option: "I don't have a registered ABN yet",
		value: "I don't have a registered ABN yet",
	},
];

export const equipment_finance_reason = [
	{
		option: "Owner Operator",
		value: "Owner Operator",
	},
	{
		option: "Purchase Additional Equipment",
		value: "Purchase Additional Equipment",
	},
	{
		option: "Replace Existing Equipment",
		value: "Replace Existing Equipment",
	},
	{
		option: "Refinance Existing Equipment",
		value: "Refinance Existing Equipment",
	},
	{
		option: "Add to Existing Equipment",
		value: "Add to Existing Equipment",
	},
	{
		option: "Other",
		value: "Other",
	},
];

export const yes_no_options = [
	{
		id: 1,
		option: "Yes",
		value: "Yes",
	},
	{
		id: 2,
		option: "No",
		value: "No",
	},
];

export const abn_years = Array.from({ length: 20 }, (_, i) => {
	const value = i + 1;
	return `${value} year${value > 1 ? "s" : ""}`;
});

export const abn_months = Array.from({ length: 12 }, (_, i) => {
	return `${i} month${i !== 1 ? "s" : ""}`;
});

export const trustee_classification = [
	{
		option: "Individual/Sole Trader",
		value: "Individual/Sole Trader",
	},
	{
		option: "Private Company",
		value: "Private Company",
	},
	{
		option: "Family Partnership",
		value: "Family Partnership",
	},
	{
		option: "Limited Partnership",
		value: "Limited Partnership",
	},
	{
		option: "Discretionary Investment Trust",
		value: "Discretionary Investment Trust",
	},
	{
		option: "Discretionary Trading Trust",
		value: "Discretionary Trading Trust",
	},
	{
		option: "Co-operative",
		value: "Co-operative",
	},
	{
		option: "Fixed Unit Trust",
		value: "Fixed Unit Trust",
	},
	{
		option: "Fixed Trust",
		value: "Fixed Trust",
	},
	{
		option: "Hybrid Trust",
		value: "Hybrid Trust",
	},
	{
		option: "Super Fund",
		value: "Super Fund",
	},
	{
		option: "Cash Management Trust",
		value: "Cash Management Trust",
	},
	{
		option: "Discretionary Services Management Trust",
		value: "Discretionary Services Management Trust",
	},
	{
		option: "Public Company",
		value: "Public Company",
	},
	{
		option: "Corporate Unit Trust",
		value: "Corporate Unit Trust",
	},
	{
		option: "Pooled Development Fund",
		value: "Pooled Development Fund",
	},
	{
		option: "Pooled Superannuation",
		value: "Pooled Superannuation",
	},
	{
		option: "Public Trading Trust",
		value: "Public Trading Trust",
	},
	{
		option: "Strata-title",
		value: "Strata-title",
	},
	{
		option: "Unlisted Public Unit Trust",
		value: "Unlisted Public Unit Trust",
	},
	{
		option: "Listed Public Unit Trust",
		value: "Listed Public Unit Trust",
	},
	{
		option: "Approved Deposit Fund",
		value: "Approved Deposit Fund",
	},
	{
		option: "Other Incorporated Entity",
		value: "Other Incorporated Entity",
	},
	{
		option: "Other Partnership",
		value: "Other Partnership",
	},
	{
		option: "Other Trust",
		value: "Other Trust",
	},
	{
		option: "Other Unincorporated Entity",
		value: "Other Unincorporated Entity",
	},
	{
		option: "ATO Regulated Self-Managed Superannuation Fund",
		value: "ATO Regulated Self-Managed Superannuation Fund",
	},
	{
		option: "First Home Saver Accounts Trust",
		value: "First Home Saver Accounts Trust",
	},
	{
		option: "Non-Regulated Superannuation Fund",
		value: "Non-Regulated Superannuation Fund",
	},
	{
		option: "Deceased Estate",
		value: "Deceased Estate",
	},
	{
		option: "LGA",
		value: "LGA",
	},
	{
		option: "Government Entity",
		value: "Government Entity",
	},
	{
		option: "State Government Entity",
		value: "State Government Entity",
	},
	{
		option: "APRA",
		value: "APRA",
	},
	{
		option: "Other",
		value: "Other",
	},
];

export const property_valuation_options = [
	{
		option: "Not Undertaken",
		value: "Not Undertaken",
	},
	{
		option: "Booked",
		value: "Booked",
	},
	{
		option: "Completed",
		value: "Completed",
	},
];

export const loanFieldsMap: Record<string, Record<string, any[]>> = {
	"Working Capital/Cash Flow": {
		businessAbnStatus: [...business_abn_status],
		abnYears: [...abn_years],
		abnMonths: [...abn_months],
		trusteeClassification: [...trustee_classification],
		businessState: [...stateOption],
		propertyOwner: [...living_status],
		creditHistory: [...credit_history],
	},
	"Business Vehicle Finance": {
		purchaseStage: [...purchase_stage],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
		propertyOwner: [...living_status],
	},
	"Truck Finance": {
		businessAbnStatus: [],
		purchaseStage: [...purchase_stage],
		financeReason: [],
		assetType: [...truck_asset_type],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
		propertyOwner: [...living_status],
	},
	"Equipment Finance": {
		businessAbnStatus: [],
		purchaseStage: [...purchase_stage],
		financeReason: [...equipment_finance_reason],
		assetType: [...equipment_asset_type],
		assetAge: [...asset_age],
		purchaseFrom: [...purchase_from],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
		propertyOwner: [...living_status],
	},
	"Commercial Property Finance": {
		businessAbnStatus: [],
		purchaseStage: [],
		financeReason: [],
		assetType: [...property_type],
		assetAge: [],
		purchaseFrom: [...purchase_from],
		// Specific Fields for Commercial Property Finance
		// propertyLocation: [...property_location],
		rentalIncome: [...yes_no_options],
		propertyValuation: [...property_valuation_options],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
		propertyOwner: [...living_status],
	},
};

// App Color Theme Settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Business Finance": {
		themeColor: "#526eb1",
		hoverColor: "#4a64a0",
		themeHeaderTxt: "#142f48",
		bulletBG: "#bfdbfe",
		breakdownBG: "#0f273e",
	},
};
